import type { RootState } from 'app/store';
import { HYDRATABLE_SLICES } from 'data/error-log-constants';
import { HydratableSliceType } from 'types/error-log';
import { omitSessionUiFields } from 'utils/error-log/omit-session-ui-fields';
import { trimSystemsForSnapshot } from 'utils/error-log/trim-systems-snapshot';

const SLICE_TRANSFORMS: Partial<
  Record<HydratableSliceType, (state: RootState) => unknown>
> = {
  systems: (state) => trimSystemsForSnapshot(state.systems),
  ui: (state) => omitSessionUiFields(state.ui)
};

export function snapshotSliceValue(
  state: RootState,
  key: HydratableSliceType
): unknown {
  const transform = SLICE_TRANSFORMS[key];
  return transform ? transform(state) : state[key];
}

export function collectSnapshotSliceValues(
  state: RootState
): Record<HydratableSliceType, unknown> {
  return Object.fromEntries(
    HYDRATABLE_SLICES.map((key) => [key, snapshotSliceValue(state, key)])
  ) as Record<HydratableSliceType, unknown>;
}
